import {
  LAYER_KEY__DRAFT_POP_ADJUSTED,
  LAYER_KEY__DRAFT_NVT_ADJUSTED,
  LAYER_KEY__DRAFT_NETWORK_ADJUSTED,
} from '../layers/infrastructureDraftAdjust';

export const SWITCH_ID__DRAFT_ADJUSTED_ALL = 'LC_DRAFT_ADJUSTED_ALL';
export const SWITCH_ID__DRAFT_ADJUSTED_POP = 'LC_DRAFT_ADJUSTED_POP';
export const SWITCH_ID__DRAFT_ADJUSTED_NVT = 'LC_DRAFT_ADJUSTED_NVT';
export const SWITCH_ID__DRAFT_ADJUSTED_NETWORK = 'LC_DRAFT_ADJUSTED_NETWORK';

export default {
  title: 'Grobplanung Änderungsanträge',
  modelNameForCASL: 'networkdistributor',
  items: [
    {
      label: 'Phasen',
      itemClass: 'selectFilter',
      layers: [
        LAYER_KEY__DRAFT_NETWORK_ADJUSTED,
        LAYER_KEY__DRAFT_POP_ADJUSTED,
        LAYER_KEY__DRAFT_NVT_ADJUSTED,
      ],
      items: [
        { title: 'Alle Flecken', filter: ['in', 'phase', 3, 4] },
        { title: 'Hellgraue Flecken', filter: ['==', ['get', 'phase'], 3] },
        { title: 'Dunkelgraue Flecken', filter: ['==', ['get', 'phase'], 4] },
      ],
      get default() {
        return this.items[0];
      },
    },
    {
      active: false,
      title: 'Alle anzeigen',
      onSwitches: [
        SWITCH_ID__DRAFT_ADJUSTED_POP,
        SWITCH_ID__DRAFT_ADJUSTED_NVT,
        SWITCH_ID__DRAFT_ADJUSTED_NETWORK,
      ],
      switchId: SWITCH_ID__DRAFT_ADJUSTED_ALL,
      itemClass: 'switch',
    },
    {
      active: false,
      title: 'Netz',
      onLayers: [LAYER_KEY__DRAFT_NETWORK_ADJUSTED],
      switchId: SWITCH_ID__DRAFT_ADJUSTED_NETWORK,
      itemClass: 'switch',
    },
    {
      active: false,
      title: 'Netzverteiler (NVT)',
      onLayers: [LAYER_KEY__DRAFT_NVT_ADJUSTED],
      switchId: SWITCH_ID__DRAFT_ADJUSTED_NVT,
      itemClass: 'switch',
    },
    {
      active: false,
      title: 'Point of Presence (POP)',
      onLayers: [LAYER_KEY__DRAFT_POP_ADJUSTED],
      switchId: SWITCH_ID__DRAFT_ADJUSTED_POP,
      itemClass: 'switch',
    },
  ],
};